import { linkEditing } from '@yola/ws-sdk';

const getLinkConfig = (linkElement) => {
  if (linkElement) {
    return linkEditing.accessors.getLinkConfig(linkElement);
  }

  return null;
};

export default getLinkConfig;
